export class AttributeOptions {
    public trimPastedText: boolean;
    public removeSpaceFromPastedText: boolean;

    public createCopy(): AttributeOptions {
        const instance = new AttributeOptions();
        instance.trimPastedText = this.trimPastedText;
        instance.removeSpaceFromPastedText = this.removeSpaceFromPastedText;

        return instance;
    }

    /**
     * Retourne une instance de AttributeOrder à partir d'une instance de IAttributeOrder.
     * @param other : Instance de IAttributeOrder.
     * @returns : Instance de AttributeOrder.
     */
    public static from(other: AttributeOptions) {
        if (!!other) {
            const instance = new AttributeOptions();

            instance.trimPastedText = other.trimPastedText;
            instance.removeSpaceFromPastedText = other.removeSpaceFromPastedText;

            return instance;
        } else {
            return null;
        }
    }
}
